import React, { useEffect, useState } from 'react';
import Modal from '../Modal/Modal';
import MediaViewer, { PreviewFile } from './MediaViewer';
import { Size } from '../../Enums/Size.enum';
import { useTreatmentContext } from '../../Services/TreatmentContext';

interface MediaViewerModalProps {
	opened: boolean;
	onClose: (reload?: boolean) => void;
	params?: any;
	file: PreviewFile;
	isSignable?: boolean;
	isSignButtonVisible?: boolean;
}

export default function MediaViewerModal(props: MediaViewerModalProps) {
	const { opened, params, file, onClose, isSignable, isSignButtonVisible } =
		props;
	const [title, setTitle] = useState(null);
	const { isCase } = useTreatmentContext();
	const [closeWithReload, setCloseWithReload] = useState(false);

	let size = Size.LG;

	useEffect(() => {
		setTitle(file?.displayName);
	}, [file]);

	const modalParams = {};
	if (file?.type === 'image') {
		modalParams['maxHeight'] = true;
	}
	if (file?.type === 'pdf') {
		modalParams['maxHeight'] = true;
		size = Size.FULLSCREEN;
	}

	return (
		<Modal
			opened={opened}
			onClose={() => onClose(closeWithReload)}
			size={size}
			wrapChat={isCase}
			{...modalParams}>
			<Modal.Header title={title} />
			<Modal.Content {...modalParams}>
				<MediaViewer
					file={file}
					onSuccess={onClose}
					params={params}
					isSignable={isSignable}
					setCloseWithReload={setCloseWithReload}
					isSignButtonVisible={isSignButtonVisible}
				/>
			</Modal.Content>
		</Modal>
	);
}
